"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var statuses_1 = require("statuses");
exports.STATUS_CODES = statuses_1.STATUS_CODES;
var Types = require("./_types");
exports.Types = Types;
var incoming_message_1 = require("./incoming-message");
exports.IncomingMessage = incoming_message_1.IncomingMessage;
var server_1 = require("./server");
exports.Server = server_1.Server;
var server_response_1 = require("./server-response");
exports.ServerResponse = server_response_1.ServerResponse;
exports.METHODS = [
    "OPTIONS",
    "HEAD",
    "GET",
    "PUT",
    "POST",
    "PATCH",
    "DELETE"
];
/**
 * @description
 * Creates a new mock http server in the browser.
 * Any arguments provided (besides the last one) are ignored in the browser.
 *
 * @param onRequest An optional function called on each request.
 */
function createServer(onRequest) {
    return new server_1.Server(arguments[arguments.length - 1]);
}
exports.createServer = createServer;
//# sourceMappingURL=index.js.map